import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function ScrollToTop({ behavior = 'smooth' } = {}) {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '')
      const element = document.getElementById(id)

      if (element) {
        element.scrollIntoView({ behavior })
        return
      }
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: behavior === 'smooth' ? 'smooth' : 'auto',
    })
  }, [pathname, hash, behavior])

  return null
}

export default ScrollToTop
